import { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import {
    setPendingTickerCommand,
    setStatuses,
    TickerStatus,
    updateStatus,
} from "store/reducers/TabsSlice";
import Error from "utils/Notifications/Error";
import Success from "utils/Notifications/Success";
import { useAppSelector } from "hooks/redux";

const WsStatusesHandler: React.FC = () => {
    const wsRef = useRef<WebSocket | null>(null);
    const dispatch = useDispatch();
    const selectedRobotId = useAppSelector(
        (state) => state.robots.selectedRobotId,
    );

    useEffect(() => {
        const connect = () => {
            const token = Cookies.get("access");
            if (!token) {
                console.warn("Токен отсутствует для ticker_status");
                return;
            }
            if (!selectedRobotId) return;
            const wsUrl = `${process.env.REACT_APP_SOCKET_SECURE}${
                process.env.REACT_APP_BASE_API_DOMAIN
            }/ws/ticker_status/?token=${encodeURIComponent(token)}&robot_id=${selectedRobotId}`;
            const socket = new WebSocket(wsUrl);

            wsRef.current = socket;

            socket.onopen = () => {
                Success("[ticker_status] Соединение установлено");
            };

            socket.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);

                    if (data.type === "snapshot" && Array.isArray(data.items)) {
                        dispatch(setStatuses(data.items as TickerStatus[]));
                    } else if (data.type === "update" && data.item) {
                        const item = data.item as TickerStatus;
                        dispatch(updateStatus(item));
                        dispatch(
                            setPendingTickerCommand({
                                ticker_name: item.ticker_name,
                                pending: false,
                            }),
                        );
                    }
                } catch (err) {
                    console.error(
                        "[ticker_status] Ошибка парсинга сообщения",
                        err,
                    );
                    Error(`[ticker_status] Ошибка парсинга сообщения: ${err}`);
                }
            };

            socket.onerror = (error) => {
                console.error("[ticker_status] Ошибка", error);
                Error(`[ticker_status] Ошибка${error}`);
            };

            socket.onclose = () => {
                console.log("[ticker_status] Соединение закрыто");

                setTimeout(() => {
                    if (wsRef.current === null && selectedRobotId) {
                        connect();
                    }
                }, 5000);
            };
        };

        connect();

        return () => {
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                wsRef.current.close();
            }
        };
    }, [dispatch, selectedRobotId]);

    return null;
};

export default WsStatusesHandler;
